import { flow, getEnv, types, getSnapshot } from "mobx-state-tree";
import { UploadStore } from "./upload-store";
import { AdapterType } from "../adapter";

export const IdentityStore = types
  .model("IdentityStore", {
    profilePhotoId: types.optional(types.string, ""),
    profilePhoto: types.optional(types.string, ""),
    isIdVerified: types.optional(types.boolean, false),
    uploadStore: types.optional(UploadStore, {}),
    loading: types.optional(types.boolean, false),
    goodQuality: types.maybeNull(types.boolean),
    has_face: types.maybeNull(types.boolean),
    valid_size: types.maybeNull(types.boolean),
  })
  .views((self) => {
    return {
      get completed() {
        let firstCondition = self.profilePhoto && self.isIdVerified;
        let secondCondition =
          self.profilePhoto && self.uploadStore.files.length > 0;
        return firstCondition || secondCondition;
      },
      get profileUploaded() {
        return Boolean(self.profilePhoto);
      },
      get idUploaded() {
        return self.isIdVerified || self.uploadStore.files.length > 0;
      },
      formValues() {
        return {
          profilePhotoId: self.profilePhotoId,
          profilePhoto: self.profilePhoto,
          isIdVerified: self.isIdVerified,
          uploadStore: {
            files: self.uploadStore.files.map((o) => ({
              name: o.name,
              // url: o.public_id,
              url: o.url,
            })),
          },
        };
      },
    };
  })
  .actions((self) => {
    const onUploadPhoto = flow(function* onUploadPhoto(_upload, slug?: string) {
      const { adapter } = getEnv<{ adapter: AdapterType }>(self);
      try {
        self.loading = true;
        let result = yield adapter.uploadAndVerifyProfile(_upload, slug);

        self.goodQuality = result.quality;
        self.profilePhotoId = result.profile_id || result.public_id;
        self.profilePhoto = result.url;
        if (self.goodQuality) {
          if (result.has_face) {
            self.has_face = result.has_face;
          } else {
            // self.profilePhotoId = "";
            // self.profilePhoto = "";
            self.has_face = false;
            self.goodQuality = false;
          }
        }
        self.loading = false;
        return result.quality ? result.url : null;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    return {
      onUploadPhoto,
    };
  });
